import React from 'react';
import moment from 'moment';
import './BrokerDateCapacityCalendar.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLongArrowLeft,
    faLongArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import cls from 'classnames';
import { Button } from 'reactstrap';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import { MomentDateFormat } from '../MomentDateFormat';
import BrokerDateCapacityManager from './BrokerDateCapacityManager';

const DAY_HEADERS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export default class BrokerDateCapacityCalendar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMonth: moment().startOf('month'),
            brokerDateCapacities: [],
            selectedBrokerDateCapacity: null,
        };
    }

    componentDidMount() {
        this.fetchDateRange();
    }

    onPreviousMonthClick = () => {
        const { currentMonth } = this.state;

        const previousMonth = moment(currentMonth).subtract(1, 'month');

        this.setState({ currentMonth: previousMonth }, () =>
            this.fetchDateRange()
        );
    };

    onNextMonthClick = () => {
        const { currentMonth } = this.state;

        const nextMonth = moment(currentMonth).add(1, 'month');

        this.setState({ currentMonth: nextMonth }, () => this.fetchDateRange());
    };

    buildWeeks(currentMonth) {
        const startOfCalendar = currentMonth.clone().startOf('week');
        const endOfCalendar = currentMonth.clone().endOf('month').endOf('week');
        const weeks = [];
        let day = startOfCalendar.clone();

        while (day.isSameOrBefore(endOfCalendar, 'day')) {
            const week = [];
            for (let i = 0; i < 7; i++) {
                week.push(day.clone());
                day.add(1, 'day');
            }
            weeks.push(week);
        }

        return weeks;
    }

    fetchDateRange = async () => {
        const { currentMonth } = this.state;
        const { brokerId, companyId } = this.props;

        const startDate = moment(currentMonth)
            .subtract(1, 'week')
            .format(MomentDateFormat.ApiUrlRequest);

        const endDate = moment(currentMonth)
            .endOf('month')
            .add(1, 'week')
            .format(MomentDateFormat.ApiUrlRequest);

        const brokerIdToUse = brokerId ?? companyId;

        const brokerDateCapacities = await util.fetch.js(
            ApiRoutes.brokerDateCapacity.getRange(
                brokerIdToUse,
                startDate,
                endDate
            )
        );

        this.setState({ brokerDateCapacities });
    };

    onDateEditFinished = (dataSaved) => {
        this.setState({ selectedBrokerDateCapacity: null });

        if (dataSaved) {
            const { onDateCapacityUpdated } = this.props;
            this.fetchDateRange();

            onDateCapacityUpdated();
        }
    };

    findCapacity(date) {
        const { brokerDateCapacities } = this.state;
        return brokerDateCapacities.find((bdc) => date.isSame(bdc.date, 'day'));
    }

    onDateSelected = (date) => {
        const { companyId, brokerId, brokerDefaultCapacity } = this.props;
        const { brokerDateCapacities } = this.state;

        const selectedBrokerDateCapacity = brokerDateCapacities.find((bdc) =>
            moment(date).isSame(bdc.date, 'day')
        ) ?? {
            companyId: companyId ?? brokerId,
            date,
            maximumAssignmentCount: brokerDefaultCapacity
                ? brokerDefaultCapacity.maximumAssignmentCount
                : 0,
        };

        this.setState({ selectedBrokerDateCapacity });
    };

    renderDay(date, currentMonth) {
        const isCurrentMonth = date.isSame(currentMonth, 'month');
        const capacity = this.findCapacity(date);
        const dayNumber = date.date();

        return (
            <td
                className={cls({ 'current-month': isCurrentMonth })}
                key={date.toISOString()}
                onClick={
                    isCurrentMonth
                        ? () => this.onDateSelected(date.toDate())
                        : undefined
                }
            >
                <div className="day-number">{dayNumber}</div>
                {capacity && (
                    <div className="max-assignment-count">
                        {capacity.maximumAssignmentCount} max
                    </div>
                )}
            </td>
        );
    }

    render() {
        const { currentMonth } = this.state;
        const weeks = this.buildWeeks(currentMonth);

        return (
            <div>
                <div className="calendar-nav-container">
                    <Button
                        color="info"
                        outline="true"
                        onClick={this.onPreviousMonthClick}
                        className="w-14"
                    >
                        <FontAwesomeIcon icon={faLongArrowLeft} />
                    </Button>

                    <strong>{currentMonth.format('MMMM YYYY')}</strong>

                    <Button
                        color="info"
                        outline="true"
                        onClick={this.onNextMonthClick}
                        className="w-14"
                    >
                        <FontAwesomeIcon icon={faLongArrowRight} />
                    </Button>
                </div>
                <table className="broker-date-capacity-calendar">
                    <thead>
                        <tr>
                            {DAY_HEADERS.map((h) => (
                                <th key={h}>{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {weeks.map((week) => (
                            <tr key={week[0].toISOString()}>
                                {week.map((day) =>
                                    this.renderDay(day, currentMonth)
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>

                <BrokerDateCapacityManager
                    {...this.props}
                    {...this.state}
                    onDateEditFinished={this.onDateEditFinished}
                />
            </div>
        );
    }
}
